//Please add the language resource
const customer = {
  customerNo:'customerNo',
  customerName:'customerName',
  customerType:'customerType',
  customerSubclassType:'customerSubclassType',
  createTime:"createTime",
  creator:"creator",
  updateTime:"updateTime",
  updater:"updater",
  msg:{
  }
};
export default customer



// WEBPACK FOOTER //
// ./src/page/md/customer/lang/customer.en.js